var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobitLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 100,
    viewBox: "0 0 80 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6 53.7496L40 42.4496L34.4 53.7496L22.5 54.7996L31.75 64.0496L27.65 77.4496L40 69.1996L52.35 77.4496L48.25 64.0496L57.5 54.7996L45.6 53.7496Z",
    fill: "#00A3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7 28.35L79.55 27.9C79.3285 27.3484 78.9869 26.853 78.55 26.45L53.55 1.45C53.1147 1.02854 52.6065 0.689696 52.05 0.45L51.6 0.3C51.1654 0.148105 50.7101 0.063791 50.25 0.05C50.15 0.05 50.05 0 50 0H10C4.5 0 0 4.5 0 10V90C0 95.5 4.5 100 10 100H70C75.5 100 80 95.5 80 90V30C80 30 79.95 29.8 79.95 29.7C79.95 29.25 79.85 28.85 79.7 28.4V28.35ZM10 89.95V9.95H45V29.95C45 32.7 47.25 34.95 50 34.95H70V89.95H10Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobitLogo);
export default __webpack_public_path__ + "static/media/jobit_logo.b4e156e2b6cc450872037f971962b1b2.svg";
export { ForwardRef as ReactComponent };